export default __webpack_public_path__ + "static/billy-vintage-blass-30b07a1c262d77ad58a430c8d6f827e5.png";